<template>
  <div class="pb-1">
    <button
      v-if="!isFavorite"
      @click.prevent="setFavoriteStatus(true)"
      class="btn btn-purple cursor-pointer"
    >
      Add to your Favorites List
      <i class="material-icons align-middle text-4xl text-yellow-400"
        >star_border</i
      >
    </button>

    <button
      v-else-if="isFavorite"
      @click.prevent="setFavoriteStatus(false)"
      class="btn btn-purple cursor-pointer"
    >
      Favorited
      <i class="material-icons align-middle text-4xl text-yellow-400">star</i>
    </button>

    <div v-else class="-mt-6 lg:mt-0 px-16">
      <ComponentLoading />
    </div>
  </div>
</template>

<script>
export default {
  name: "AddToFavorites",
  props: {
    promoProfileId: Number,
    isFavorite: Boolean,
  },
  methods: {
    setFavoriteStatus(status) {
      this.$emit("set-favorite-status", status);
    },
  },
};
</script>
